import React from 'react';
import {Formik} from 'formik';
import PropTypes from 'prop-types';
import {useNewReportState} from "presentation/new-report/NewReportContext";
import DispatchForm from './dispatch-form/DispatchForm';
import {DispatchSchema} from './dispatch-data-schema';

const DispatchData = () => {
  const {
    dispatchDataRef,
    dataState
  } = useNewReportState();

  return (
    <Formik
      initialValues={dataState.dispatchData}
      validationSchema={DispatchSchema(dataState.dispatchData)}
      onSubmit={() => {
      }}>
      {
        (formik) => {
          const {
            values,
            handleSubmit,
            setFieldValue,
            validateForm,
            setFieldTouched,
            isValid,
            errors,
            resetForm
          } = formik;

          dispatchDataRef.current = {
            validateForm,
            handleSubmit,
            isValid,
            values,
            errors,
            setFieldValue,
            setFieldTouched,
            resetForm,
          };

          return (
            <div className="p-sm overflow-x-hidden-sm">
              <DispatchForm
                setFieldValue={setFieldValue}
                setFieldTouched={setFieldTouched}
                values={values}/>
            </div>
          )
        }}
    </Formik>)
}

DispatchData.propTypes = {
  userInfo: PropTypes.any,
  initialValues: PropTypes.object
};


export default DispatchData;
